import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import xss from "xss";
import { uniqueKey } from "../utils/functions/uniqueKey";

class Messages extends Component {
  render() {
    let className = "";
    if (this.props.type === "info") className = " text-black";
    if (this.props.type === "error") className = " text-danger";
    return (
      <Modal.Dialog size="lg" className="mt-5">
        {this.props.message
          ? <Modal.Header className={className}>{xss(this.props.message)}</Modal.Header>
          : null
        }
        <Modal.Body>
          {Array.isArray(this.props.messageText)
            ? this.props.messageText.map((abschnitt) =>
              <p key={uniqueKey(abschnitt)} className="text-left fw-bold fs-6">{xss(abschnitt)}</p>
            )
            : <p>{xss(this.props.messageText || "")}</p>
          }
        </Modal.Body>
        {this.props.children
          ? <Modal.Footer>{this.props.children}</Modal.Footer>
          : null
        }
      </Modal.Dialog>
    );
  }
}

export default Messages;
